<template>
  <BasicBtnGroup class="invite-btn-group" @primeClick="$emit('inviteMore')" @defClick="$emit('imCall')">
    <template slot="defContent"
      ><SvgIcon icon-class="invite" class-name="mr-9" />{{$t('home.Appointment')}}</template
    >
    <template slot="primaryContent"
      ><SvgIcon icon-class="video"  class-name="mr-9" />{{$t('home.AppointmentNow')}}</template
    >
  </BasicBtnGroup>
</template>
<script>
import BasicBtnGroup from '../../behavior/basic-btn-group/index.vue'
import SvgIcon from '@/components/behavior/svg-icon/index.vue'
// 发起预约，立即呼叫按钮组
export default {
  name: 'InviteBtnGroup',
  components: {
    SvgIcon,
    BasicBtnGroup
  },
  props: {
    layout: {
      type: String, // 两个按钮的位置关系 'horizontal', 'vertical'
      default: 'horizontal'
    }
  }
}
</script>
<style lang="less" scoped>
@import url(~@/styles/font.less);
.invite-btn-group {
  display: flex;
  justify-content: space-between;
  ::v-deep .ant-btn {
    padding: 10px 20px;
  }
}
</style>
